import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Editorial split-image section with parallax on the image.
 * Uses left column for image, right for a "signature project" quote.
 */
export default function SignatureSpotlight() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
    const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

    return (
        <section
            ref={ref}
            data-testid="signature-spotlight"
            className="relative bg-forest-900 text-ivory py-24 md:py-40 overflow-hidden"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-center">
                <div className="md:col-span-6 relative">
                    <div className="relative overflow-hidden aspect-[4/5] md:aspect-[4/5.4] bg-forest-800">
                        <motion.img
                            style={{ y, scale }}
                            src="https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?ixlib=rb-4.1.0&q=85"
                            alt="Signature project"
                            className="absolute inset-0 h-[115%] w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-forest-900/25" />
                        <div className="absolute top-6 left-6 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/90">
                            01 / Featured
                        </div>
                        <div className="absolute bottom-6 left-6 flex items-center gap-2">
                            <span className="h-2 w-2 bg-lime" />
                            <span className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory">
                                Kalinga Heights · Bhubaneswar
                            </span>
                        </div>
                    </div>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-15% 0px" }}
                    transition={{ duration: 1.05, ease: EASE }}
                    className="md:col-span-6 md:pl-8 lg:pl-14"
                >
                    <div className="flex items-center gap-4 mb-6">
                        <span className="h-px w-10 bg-lime" />
                        <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">
                            The signature project
                        </span>
                    </div>
                    <blockquote className="font-serif-display text-3xl md:text-[2.75rem] lg:text-[3.15rem] leading-[1.05] tracking-tight text-ivory">
                        “A twenty-eight-storey composition of alternating loggias and planted
                        terraces. Each residence opens to the Kuakhai river on one side, and
                        the temple skyline on the other.”
                    </blockquote>
                    <div className="mt-10 flex items-center gap-4">
                        <div className="h-10 w-10 border border-ivory/25 flex items-center justify-center font-mono-mini text-[10px] tracking-[0.18em] text-lime">
                            KH
                        </div>
                        <div>
                            <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/70">
                                Ar. Devika Panda — Principal
                            </div>
                            <div className="text-ivory/50 text-sm mt-1">
                                Studio KLiving · Bhubaneswar
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
